import { gql, useMutation } from '@apollo/client';

import { DeleteApiKey } from './__generated__/DeleteApiKey';
import { GET_APIKEYS } from './useGetApiKeys';

const DELETE_APIKEYS = gql`
  mutation DeleteApiKey($id: String!) {
    deactivateApiKey(id: $id) {
      apiKey {
        id
        name
        deactivatedAt
      }
      error
    }
  }
`;

export default function useDeleteApiKey() {
  const [deleteApiKeyQL, { data, error, loading }] = useMutation<DeleteApiKey>(
    DELETE_APIKEYS,
    {
      refetchQueries: [GET_APIKEYS, 'GetApiKeys'],
    },
  );
  const deleteApiKey = (id: string | undefined) => {
    if (id) {
      return deleteApiKeyQL({
        variables: { id },
      })
        .then(({ data }) => data)
        .catch(err => {
          console.log(err);
          return err;
        });
    }
    return Promise.resolve(false);
  };
  return [deleteApiKey, { data, error, loading }] as const;
}
